import { PropsWithChildren, useMemo } from 'react';

import { OperationContext, OperationContextProps } from './OperationContext';

export const OperationProvider = ({
  children,
  operation,
  onChangeStatus,
  onDelete,
  onEnableEdit,
  onDisableEdit,
}: OperationContextProps & PropsWithChildren) => {
  const value = useMemo(
    () => ({
      operation,
      onChangeStatus,
      onDelete,
      onEnableEdit,
      onDisableEdit,
    }),
    [operation, onChangeStatus, onDelete, onEnableEdit, onDisableEdit]
  );

  return (
    <OperationContext.Provider value={value}>
      {children}
    </OperationContext.Provider>
  );
};
